module.exports = __webpack_public_path__ + "static/media/img3.815d04ec.png";